import React from 'react';
import { TextButton as TPATextButton, TextButtonPriority } from 'wix-ui-tpa/cssVars';
import { classes } from './ricos-viewer.st.css';
import { useTranslation } from '../../contexts/translation-context';
export const ToggleTruncateButtonWUT = _ref => {
  let {
    isTruncated,
    onClick
  } = _ref;
  const {
    t
  } = useTranslation();
  const buttonText = isTruncated ? t('field.rich-text.read-more-button.label') : t('field.rich-text.read-less-button.label');
  return /*#__PURE__*/React.createElement(TPATextButton, {
    priority: TextButtonPriority.primary,
    onClick: onClick,
    className: classes.truncateToggle,
    "data-hook": "toggle-truncate-button"
  }, buttonText);
};
//# sourceMappingURL=toggle-truncate-button-wut.js.map